import Appsignal from '@appsignal/javascript'
import { plugin as breadcrumbsConsole } from '@appsignal/plugin-breadcrumbs-console'
import { plugin as breadcrumbsNetwork } from '@appsignal/plugin-breadcrumbs-network'

// Read configuration from meta tags injected by Rails
function getMetaContent (name) {
  const meta = document.querySelector(`meta[name="${name}"]`)
  return meta ? meta.content : null
}

const key = getMetaContent('appsignal-frontend-key')
const revision = getMetaContent('appsignal-revision')

// Create AppSignal instance (inactive if no key present)
const appsignal = new Appsignal({
  key: key || '',
  revision: revision || 'development',
  ignoreErrors: [
    // Ignore ResizeObserver errors which are benign and commonly triggered by browser extensions
    /ResizeObserver loop/
  ]
})

// Only register plugins if we have a valid key
if (key) {
  // Capture console output as debugging breadcrumbs
  appsignal.use(breadcrumbsConsole())

  // Track XHR/fetch requests as breadcrumbs for debugging context
  appsignal.use(breadcrumbsNetwork())
}

export { appsignal }
